import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "lozenge-content" };
const _hoisted_2 = { class: "icon-container" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "account-type-label" };
const _hoisted_5 = {
    key: 0,
    class: "account-type-text"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
    key: 0,
    class: "count-badge"
};
const _hoisted_9 = {
    key: 1,
    class: "add-badge"
};
const _hoisted_10 = {
    key: 2,
    class: "arrow-badge"
};
const _hoisted_11 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountTypeLozenge',
    props: {
        accountType: {},
        accountCount: { default: null },
        iconUrl: {},
        isAddButton: { type: Boolean, default: false },
        compactMode: { type: Boolean, default: true },
        text: { default: null },
        textIcon: { default: null }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        function handleClick() {
            emit('click', {
                accountType: props.accountType,
                isAddButton: props.isAddButton,
            });
        }
        function formatText(text) {
            return text.replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>');
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["account-type-lozenge", { 'expanded-mode': !_ctx.compactMode }]),
                onClick: handleClick
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_ctx.iconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.iconUrl,
                                alt: _ctx.accountType,
                                class: "icon"
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                        class: _normalizeClass(["text-content", { 'no-text': !(!_ctx.compactMode && _ctx.text) }])
                    }, [
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.accountType), 1),
                        (!_ctx.compactMode && _ctx.text)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                (_ctx.textIcon)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.textIcon,
                                        alt: _ctx.accountType,
                                        class: "text-icon"
                                    }, null, 8, _hoisted_6))
                                    : _createCommentVNode("", true),
                                _createElementVNode("span", {
                                    class: "subText",
                                    innerHTML: formatText(_ctx.text)
                                }, null, 8, _hoisted_7)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2)
                ]),
                (!_ctx.isAddButton && _ctx.compactMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.accountCount), 1))
                    : (_ctx.isAddButton && _ctx.compactMode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_v_icon, {
                                size: "12",
                                color: "white"
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("mdi-plus")
                                ])),
                                _: 1
                            })
                        ]))
                        : (!_ctx.compactMode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("img", {
                                    class: "arrow",
                                    src: require('@/assets/arrow-right.png')
                                }, null, 8, _hoisted_11)
                            ]))
                            : _createCommentVNode("", true)
            ], 2));
        };
    }
});
